import { render, staticRenderFns } from "./toast.vue?vue&type=template&id=5c6952bc&scoped=true&"
var script = {}
import style0 from "./toast.vue?vue&type=style&index=0&id=5c6952bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6952bc",
  null
  
)

export default component.exports